module.exports = __webpack_public_path__ + "img/R01.be6d1e4d.png";